import { FC, useEffect, useContext } from "react";
import { Box, Button } from "@material-ui/core";
import { BundleFormModalContext } from "../modals/BundleFormModalContext";
import {
  BundleContentTypeEnum,
  BundlePlatformEnum,
} from "../../../generated/graphql";

export const PLATFORM_LABELS: { [key in BundlePlatformEnum]?: string } = {
  [BundlePlatformEnum.Ios]: "IOS",
  [BundlePlatformEnum.Android]: "Android",
  [BundlePlatformEnum.WebGl]: "WebGL",
  [BundlePlatformEnum.Vr]: "VR",
  [BundlePlatformEnum.InteractiveWhiteboardAndroid]:
    "Android for board",
  [BundlePlatformEnum.InteractiveWhiteboardWindows]:
    "Windows for board",
};
export const ALLOWED_PLATFORMS_BY_TYPE: { [key in BundleContentTypeEnum]?: BundlePlatformEnum[] } = {
  [BundleContentTypeEnum.ArWebgl]: [
    BundlePlatformEnum.Ios,
    BundlePlatformEnum.Android,
    BundlePlatformEnum.WebGl,
    BundlePlatformEnum.InteractiveWhiteboardAndroid,
    BundlePlatformEnum.InteractiveWhiteboardWindows,
  ],
  [BundleContentTypeEnum.InteractiveExercise]: [
    BundlePlatformEnum.Ios,
    BundlePlatformEnum.Android,
    BundlePlatformEnum.WebGl,
    BundlePlatformEnum.InteractiveWhiteboardAndroid,
    BundlePlatformEnum.InteractiveWhiteboardWindows,
  ],
  [BundleContentTypeEnum.ExperimentVr]: [BundlePlatformEnum.Vr],
};

const platformKeys = Object.keys(PLATFORM_LABELS) as BundlePlatformEnum[];

export const PlatformTabs: FC = () => {
  const { modelData, activePlatform, handleActivePlatform } = useContext(
    BundleFormModalContext,
  );
  const contentType = modelData?.contentType;

  const getIsDisabled = (platformKey: BundlePlatformEnum) => {
    if (!contentType) return true;
    return !ALLOWED_PLATFORMS_BY_TYPE[contentType]?.includes(platformKey);
  };

  useEffect(() => {
    if (!contentType) {
      handleActivePlatform(null);
      return;
    }
    const firstEnabled = platformKeys.find((key) => !getIsDisabled(key));
    if (firstEnabled) {
      handleActivePlatform(firstEnabled);
    }
  }, [contentType]);

  return (
    <Box display="flex" flexWrap="wrap" mt={2} gridGap={6} maxWidth={520}>
      {platformKeys.map((key) => {
        const disabled = getIsDisabled(key);

        return (
          <Button
            key={key}
            onClick={() => handleActivePlatform(key)}
            disabled={disabled}
            variant="outlined"
            style={{
              textTransform: "none",
              border: "2px solid black",
              borderRadius: 12,
              backgroundColor: activePlatform === key ? "#ffe066" : "#ffffff",
              fontWeight: activePlatform === key ? "bold" : "normal",
              color: "black",
              marginRight: 8,
              marginBottom: 8,
              opacity: disabled ? 0.4 : 1,
            }}
          >
            {PLATFORM_LABELS[key]}
          </Button>
        );
      })}
    </Box>
  );
};
